import { React, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as ShowerIcon } from "../../assets/images/bath.svg";
import { ReactComponent as BedIcon } from "../../assets/images/bed.svg";
import { ReactComponent as AreaIcon } from "../../assets/images/sqreft.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/phone.svg";
import { ReactComponent as UserIcon } from "../../assets/images/user.svg";
import { ReactComponent as MailIcon } from "../../assets/images/mail.svg";
import { ReactComponent as LocIcon } from "../../assets/svg/loc-icon.svg";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSelector, useDispatch } from "react-redux";
import { agentDashboardSelector } from "../../redux/agentDashboard";
import { GetAllPropertyToBeAuditedData, GetAllPropertyScheduledForAuditData } from "../../services/propertyScheduledForVisit";
import InputBase from "@mui/material/InputBase";
import Loader from "../../components/loader/Loader";
import { useNavigate } from "react-router-dom";
import ScheduleVisitDialog from "../../components/Dialog/Buy-dashboard-dialog/ScheduleVisitAuditDialog";
import { getAgentTimeSlotsService } from "../../services/SchedulePropertyVisit";
import moment from "moment";
import { formatMozambicanMetical } from "../../lib/helper";
import TableHead from "@mui/material/TableHead";

const AuditProperty = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [scheduleAppointment, setScheduleAppointment] = useState(false);
  const [selectedProp, setSelectedProp] = useState();
  const { propertyToBeAuditedData } = useSelector(agentDashboardSelector);
  const { propertyScheduledForAuditedData } = useSelector(
    agentDashboardSelector
  );
  const [loading, setLoading] = useState(false);
  const [slotsList, setSlotsList] = useState([]);
  const [navParams, setNavParams] = useState({
    navTitle: "Agent Dashboard",
    navSubTitle: "Welcome to Easy Property Agent Dashboard",
  });
  useEffect(() => {
    getMyPropertyList();
    getMyPropertyListScheduledForAudit();
    getTimeSlotsList();
  }, []);

  const getMyPropertyList = () => {
    dispatch(GetAllPropertyToBeAuditedData());
  };
  const getMyPropertyListScheduledForAudit = () => {
    dispatch(GetAllPropertyScheduledForAuditData());
  };


  const setAppointmentHandler = (id) => {
    setSelectedProp(id);
    setScheduleAppointment(true);
  };

  const getTimeSlotsList = async () => {
    try {
      setLoading(true);
      let data = await getAgentTimeSlotsService();
      let slotList = data?.map((item, index) => {
        return {
          label: item?.slot_from + "-" + item?.slot_to,
          value: item?.id,
          item,
        };
      });
      setSlotsList(slotList);
      throw data;
    } catch (e) {
      console.log(e, "error");
      setLoading(false);
    }
  }

  return (
    <>
      <ScheduleVisitDialog
        scheduleAppointment={scheduleAppointment}
        setScheduleAppointment={setScheduleAppointment}
        id={selectedProp}
      />
      {propertyToBeAuditedData?.loading && <Loader />}

      <Box
        component="section"
        sx={{
          background: "#FFFFFF",
          borderRadius: "24px",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.04)",
          border: "1px solid #F1F5F9",
          overflow: "hidden",
          mt: 2,
          mb: 4,
        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 4,
          borderBottom: "1px solid #F1F5F9",
          background: "linear-gradient(to right, #F8FAFC, #FFFFFF)"
        }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.5rem",
              color: "#0F172A",
              fontFamily: "Outfit, sans-serif"
            }}
          >
            {t("Agent_dashboard.Property to be Audited")}
          </Typography>
          <Button
            sx={{
              textTransform: 'none',
              fontSize: "0.875rem",
              color: "#0085FD",
              fontWeight: "700",
              borderRadius: "8px",
              px: 2,
              py: 1,
              "&:hover": {
                backgroundColor: "rgba(0, 133, 253, 0.08)",
              },
            }}
            onClick={() => navigate(`/property-to-be-audited`)}
          >
            {t("Agent_dashboard.View All")}
          </Button>
        </Box>
        <Box sx={{ p: 0 }}>
          <TableContainer sx={{
            boxShadow: 'none',
            '& svg': {
              width: '18px !important',
              height: '18px !important',
              '& path, & circle, & rect, & ellipse': {
                fill: '#0085FD !important'
              },
              '& [stroke]': {
                stroke: '#0085FD !important',
                fill: 'none !important'
              }
            }
          }}>
            <Table sx={{ minWidth: 1023 }} aria-label="simple table">
              <TableHead sx={{ bgcolor: "#F8FAFC" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5, px: 4, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em' }}>{t("Agent_dashboard.Property")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}></TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Location")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Details")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Price")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5, pr: 4, textAlign: 'center' }}>{t("Agent_dashboard.Action")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertyToBeAuditedData?.items?.data && propertyToBeAuditedData?.items?.data.length > 0 ? (
                  propertyToBeAuditedData?.items?.data
                    .slice(0, 5)
                    .map((row, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          cursor: " pointer",
                          transition: 'all 0.2s',
                          "&:hover": { bgcolor: "rgba(248, 250, 252, 0.8)" },
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell sx={{ width: 120, py: 3, pl: 4 }}
                          onClick={() => navigate(`/view-property-agent/${row?.id}`)}
                        >
                          <img
                            src={row?.property_media[0]?.image_url ? row?.property_media[0]?.image_url : "../../assets/img/rectangle.png"}
                            style={{
                              width: '100px',
                              height: '75px',
                              objectFit: 'cover',
                              borderRadius: '12px',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                            }}
                          />
                        </TableCell>

                        <TableCell
                          sx={{ py: 3 }}
                          onClick={() => navigate(`/view-property-agent/${row?.id}`)}
                        >
                          <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#1E293B', mb: 0.5, fontFamily: 'Outfit' }}>
                            {row?.property_title}
                          </Typography>
                          <Typography sx={{ fontSize: '0.8125rem', color: '#64748B', mb: 1.5, fontWeight: 500 }}>
                            {row?.property_category?.property_category_title}
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-block',
                              px: 1.5,
                              py: 0.5,
                              borderRadius: '6px',
                              bgcolor: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "rgba(68, 125, 239, 0.1)" : "rgba(100, 116, 139, 0.1)",
                              color: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "#447DEF" : "#64748B",
                              fontSize: '0.6875rem',
                              fontWeight: 800,
                              textTransform: 'uppercase',
                              letterSpacing: '0.05em'
                            }}
                          >
                            {(row?.property_type_master_id == 2 ||
                              row?.property_type_master_id == 5) ? "For Sale" : (row?.property_type_master_id == 3 || row?.property_type_master_id == 6)
                              ? "For Rent" : (row?.property_type_master_id == 4) ? "For Share" : ""}
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{ color: "#475569", fontSize: "0.875rem", lineHeight: "1.6", py: 3 }}
                          onClick={() => navigate(`/view-property-agent/${row?.id}`)}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
                            <LocIcon style={{ marginTop: '2px' }} />
                            <Box component="span" sx={{ fontWeight: 500 }}>
                              {row?.address_1}, {row?.address_2} <br />
                              <Box component="span" sx={{ color: '#94A3B8' }}>{row?.city}, {row?.state}</Box>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{ color: "#475569", fontSize: "0.875rem", py: 3 }}
                          onClick={() => navigate(`/view-property-agent/${row?.id}`)}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                              <AreaIcon /> {row?.total_property_area}
                            </Box>
                            {row?.no_of_bedrooms > 0 &&
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                                <BedIcon /> {row?.no_of_bedrooms}
                              </Box>
                            }
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{ py: 3 }}
                          onClick={() => navigate(`/view-property-agent/${row?.id}`)}
                        >
                          <Typography sx={{ color: "#0085FD", fontWeight: 800, fontSize: "1.125rem", fontFamily: 'Outfit' }}>
                            {formatMozambicanMetical(row?.offered_price)}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ py: 3, pr: 4, textAlign: 'center' }}>
                          <Button
                            variant="contained"
                            disableElevation
                            onClick={() => setAppointmentHandler(row?.id)}
                            sx={{
                              bgcolor: "#0085FD",
                              color: "#FFFFFF",
                              borderRadius: "10px",
                              textTransform: "none",
                              fontWeight: "700",
                              fontSize: "0.875rem",
                              px: 3,
                              py: 1.25,
                              minWidth: '100px',
                              "&:hover": {
                                bgcolor: "#0072DB",
                                boxShadow: '0 4px 12px rgba(0, 133, 253, 0.25)'
                              }
                            }}
                          >
                            Accept
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  !propertyToBeAuditedData?.loading && (
                    <TableRow>
                      <TableCell colSpan={6} sx={{ py: 8, textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#94A3B8', fontFamily: 'Outfit' }}>
                          No property found for audit
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      <Box
        component="section"
        sx={{
          background: "#FFFFFF",
          borderRadius: "24px",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.04)",
          border: "1px solid #F1F5F9",
          overflow: "hidden",
          mt: 2,
          mb: 4,
        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 4,
          borderBottom: "1px solid #F1F5F9",
          background: "linear-gradient(to right, #F8FAFC, #FFFFFF)"
        }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.5rem",
              color: "#0F172A",
              fontFamily: "Outfit, sans-serif"
            }}
          >
            {t("Agent_dashboard.Property Scheduled for Audited")}
          </Typography>
          <Button
            sx={{
              textTransform: 'none',
              fontSize: "0.875rem",
              color: "#0085FD",
              fontWeight: "700",
              borderRadius: "8px",
              px: 2,
              py: 1,
              "&:hover": {
                backgroundColor: "rgba(0, 133, 253, 0.08)",
              },
            }}
            onClick={() => navigate(`/schedule-property-audited`)}
          >
            {t("Agent_dashboard.View All")}
          </Button>
        </Box>
        <Box sx={{ p: 0 }}>
          <TableContainer sx={{
            boxShadow: 'none',
            '& svg': {
              width: '18px !important',
              height: '18px !important',
              '& path, & circle, & rect, & ellipse': {
                fill: '#0085FD !important'
              },
              '& [stroke]': {
                stroke: '#0085FD !important',
                fill: 'none !important'
              }
            }
          }}>
            <Table sx={{ minWidth: 1023 }} aria-label="simple table">
              <TableHead sx={{ bgcolor: "#F8FAFC" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5, px: 4, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em' }}>{t("Agent_dashboard.Property")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}></TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Price")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Location")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Details")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Client Info")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5, pr: 4 }}>{t("Agent_dashboard.Schedule")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertyScheduledForAuditedData?.items?.data && propertyScheduledForAuditedData.items?.data.length > 0 ? (
                  propertyScheduledForAuditedData.items?.data
                    .slice(0, 5).sort((a, b) => a.status > b.status ? 1 : -1)
                    .map((row, i) => {
                      const newTempObj = slotsList?.find((timing) => {
                        return Number(timing?.value) == Number(row?.timeslot);
                      });

                      return (
                        <TableRow
                          key={i}
                          sx={{
                            cursor: " pointer",
                            transition: 'all 0.2s',
                            "&:hover": { bgcolor: "rgba(248, 250, 252, 0.8)" },
                            "&:last-child td, &:last-child th": { border: 0 },
                            opacity: row?.status == 3 ? 0.6 : 1,
                          }}
                          onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}
                        >
                          <TableCell sx={{ width: 120, py: 3, pl: 4 }}>
                            <img
                              src={row?.image_url ? row?.image_url : "../../assets/img/rectangle.png"}
                              style={{
                                width: '100px',
                                height: '75px',
                                objectFit: 'cover',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                              }}
                            />
                          </TableCell>

                          <TableCell
                            sx={{ py: 3 }}
                          >
                            <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#1E293B', mb: 0.5, fontFamily: 'Outfit' }}>
                              {row?.property_title}
                            </Typography>
                            <Typography sx={{ fontSize: '0.8125rem', color: '#64748B', mb: 1.5, fontWeight: 500 }}>
                              {row?.property_category_title}
                            </Typography>
                            <Box
                              sx={{
                                display: 'inline-block',
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                bgcolor: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "rgba(68, 125, 239, 0.1)" : "rgba(100, 116, 139, 0.1)",
                                color: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "#447DEF" : "#64748B",
                                fontSize: '0.6875rem',
                                fontWeight: 800,
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em'
                              }}
                            >
                              {(row?.property_type_master_id == 2 ||
                                row?.property_type_master_id == 5) ? "For Sale" : (row?.property_type_master_id == 3 || row?.property_type_master_id == 6)
                                ? "For Rent" : (row?.property_type_master_id == 4) ? "For Share" : ""}
                            </Box>
                          </TableCell>

                          <TableCell
                            sx={{ py: 3 }}
                          >
                            <Typography sx={{ color: "#0085FD", fontWeight: 800, fontSize: "1.125rem", fontFamily: 'Outfit' }}>
                              {formatMozambicanMetical(row?.offered_price)}
                            </Typography>
                          </TableCell>

                          <TableCell
                            sx={{ color: "#475569", fontSize: "0.875rem", lineHeight: "1.6", py: 3 }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
                              <LocIcon style={{ marginTop: '2px' }} />
                              <Box component="span" sx={{ fontWeight: 500 }}>
                                {row?.address_1}, {row?.address_2} <br />
                                <Box component="span" sx={{ color: '#94A3B8' }}>{row?.city}, {row?.state}</Box>
                              </Box>
                            </Box>
                          </TableCell>

                          <TableCell
                            sx={{ color: "#475569", fontSize: "0.875rem", py: 3 }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                                <AreaIcon /> {row?.total_property_area}
                              </Box>
                              {row?.no_of_bedrooms > 0 &&
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                                  <BedIcon /> {row?.no_of_bedrooms}
                                </Box>
                              }
                            </Box>
                          </TableCell>

                          <TableCell sx={{ py: 3 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: '#1E293B', fontWeight: 600, fontSize: '0.875rem' }}>
                                <UserIcon style={{ width: 16, marginRight: 8 }} /> {row?.first_name} {row?.last_name}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: '#64748B', fontSize: '0.8125rem' }}>
                                <MailIcon style={{ width: 16, marginRight: 8 }} /> {row?.email}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: '#64748B', fontSize: '0.8125rem' }}>
                                <PhoneIcon style={{ width: 16, marginRight: 8 }} /> {row?.contact_number}
                              </Box>
                            </Box>
                          </TableCell>

                          <TableCell sx={{ py: 3, pr: 4 }}>
                            <Box sx={{
                              p: 1.5,
                              borderRadius: '12px',
                              bgcolor: 'rgba(0, 133, 253, 0.04)',
                              border: '1px solid rgba(0, 133, 253, 0.1)',
                              minWidth: 140
                            }}>
                              <Typography sx={{ color: '#0085FD', fontWeight: 700, fontSize: "0.875rem", mb: 0.5 }}>
                                {moment(row?.schedule_date).format("DD MMM, YYYY")}
                              </Typography>
                              <Typography sx={{ color: '#64748B', fontSize: '0.75rem', fontWeight: 600 }}>
                                {newTempObj?.item?.slot_from} - {newTempObj?.item?.slot_to}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  !propertyScheduledForAuditedData?.loading && (
                    <TableRow>
                      <TableCell colSpan={7} sx={{ py: 8, textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#94A3B8', fontFamily: 'Outfit' }}>
                          No property scheduled for audit
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};
export default AuditProperty;
